// @ts-ignore
import { SPECIAL_CHARACTERS_FIRST_LAST_NAME, SPECIAL_CHARACTERS_TEAM_NAME } from 'app/validators/base/constants'

export const areSpecialCharactersInFirstLastName = (value: string) =>
  value && new RegExp(SPECIAL_CHARACTERS_FIRST_LAST_NAME).test(value)

export const areSpecialCharactersInTeamName = (value: string) =>
  value && new RegExp(SPECIAL_CHARACTERS_TEAM_NAME).test(value)
